import { Avatar, Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DataGrideView from "../../../../Component/DataGrideView/DataGrideView";
import { API_URL } from "../../../../Apis/config";
import SplitButton from "../../../../Component/Button/SplitButton";
import ConfirmationDailog from "../../../../Component/Dailog/ConfirmationDailog";
import AddUpdateWebCityDailog from "../../../../Component/Dailog/web/AddUpdateWebCity";
import {
  DELETE_WEB_BRAND,
  GET_WEB_BRAND,
} from "../../../../Apis/web/brand_api";
import AddUpdateWebBrandDailog from "../../../../Component/Dailog/web/AddUpdateWebBrand";

function WebBrand() {
  const [open, setOpen] = useState(false);
  const [row, setRow] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isLoading, SetIsLoading] = useState(true);

  const getData = async () => {
    SetIsLoading(true);
    const res = await GET_WEB_BRAND();

    if (res && res?.s) {
      setRow(res?.r ?? []);
    } else {
      setRow([]);
    }
    SetIsLoading(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (v) => {
    if (v) {
      getData();
    }
    setSelectedRow(null);
    setOpen(false);
  };

  const handleCloseDelete = async (v) => {
    if (v) {
      await DELETE_WEB_BRAND(selectedRow.id);
      getData();
    }
    setSelectedRow(null);
    setDeleteOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "SR.",
      filterable: false,
      headerAlign: "center",
      align: "center",
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        // console.log(params);
        return params.api.getRowIndex(params.row.id) + 1;
      },
    },
    {
      field: "name",
      headerName: "Name",
      filterable: false,
      minWidth: 210,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        // console.log(params);
        return (
          <Typography sx={{ py: 1, fontSize: "13px" }}>
            {params.value}
          </Typography>
        );
      },
    },

    {
      field: "logo",
      headerName: "Logo",
      filterable: false,
      minWidth: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return params.value ? (
          <Avatar
            onClick={() =>
              window.open(
                API_URL.baseUrl + API_URL.webBrandLogo + params.value,
                "_blank"
              )
            }
            sx={{ height: "30px", width: "30px", cursor: "pointer" }}
            src={API_URL.baseUrl + API_URL.webBrandLogo + params.value}
          />
        ) : (
          "-"
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 70,
      type: "number",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <SplitButton
          key={params.id}
          title={params.value}
          // isView={rightsUser.includes(4) ? 1 : null}
          dataId={params.row.id}
          isDelete={1}
          isEdit={1}
          onEdit={onEdit}
          onView={null}
          onDelete={onDelete}
          // deleteText="Delete"
        />
      ),
    },
  ];

  const onEdit = (id) => {
    // console.log(id, "id");
    setSelectedRow(() => row.find((v) => v.id == id));
    setOpen(true);
  };

  const onDelete = (id) => {
    setSelectedRow(() => row.find((v) => v.id == id));
    setDeleteOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          flexDirection: "column",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            width: "125px",
            mb: 1,
          }}
          onClick={handleOpen}
        >
          <Typography sx={{ color: "primary.main" }}>Add Brand</Typography>
        </Button>

        <Box sx={{ boxShadow: "3px 3px 7px 0px #00000040", width: "100%" }}>
          <DataGrideView
            rows={row}
            columns={columns}
            // callBack={callBack}
            isLoading={isLoading}
            sx={{
              height: "75vh",
            }}
            autoHeight={true}
          />
        </Box>
      </Box>
      {open && (
        <AddUpdateWebBrandDailog
          open={open}
          handleOnClose={handleClose}
          row={selectedRow}
        />
      )}

      {deleteOpen && (
        <ConfirmationDailog
          handleOnClose={handleCloseDelete}
          open={deleteOpen}
          content="Are you sure, You want to delete this brand?"
          title="Delete Brand!"
        />
      )}
    </>
  );
}

export default WebBrand;
